module.exports = __webpack_public_path__ + "img/il_empty_shared_folder.e7733222.svg";